import { ContractList } from './../models/ContractList';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ContractListService } from './contract-list.service';

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: ['./contract-list.component.css']
})
export class ContractListComponent implements OnInit {

  public codeUser: string = localStorage.getItem('CODIGO_CADASTRO_GERAL') ?? "";
  public dataSourceContractList: MatTableDataSource<ContractList> = new MatTableDataSource<ContractList>();
  public displayedColumnsContracts: string[];

  constructor(
    private service: ContractListService,
    private router: Router
  ) {
    this.displayedColumnsContracts = [
      'GEN_CONTRATO',
      'DESCRICAO',
      'DESCRICAO_LOJA',
      'VALOR_BASE',
      'DATA_LOCACAO',
      'FINALIZAR_CONTRATO_DATA',
      'INADIMPLENCIA',
    ];
  }

  ngOnInit(): void {
    this.service.showSpinner();
    this.service.getContractList().subscribe((ContractList) => {
      this.dataSourceContractList = new MatTableDataSource<ContractList>(<any>ContractList);
      this.service.hideSpinner();
    });
  }

  openContract(id: string): void {
    this.router.navigate(['principal/contrato/' + id]);
  }
  returnToDashboard(): void{
    this.router.navigate(['principal/dashboard']);
  }

}
